:host {
  display: block;
  max-width: 100%;
  position: relative;
}

.label {
  gz-text {
    display: inline;
  }
}

gz-text[class*='time'] {
  min-width: 90px;
  color: var(--chart-300-icon-buttons);
}

.label-icon {
  svg {
    fill: var(--white-layout-301-level-0-elevation);
  }
}

.content-loader {
  padding-top: calc(var(--spacer) + 4px);
}

.header-loader {
  width: 240px;
}

.header {
  max-width: calc(100% - 32px);
}

gz-icon-button {
  padding: 0 0 0 var(--spacer);
}

::slotted(*) {
  padding: var(--spacer) 0;
}

.logo-circle {
  margin: calc(var(--spacer) / 2);

  &:before {
    content: "";
    position: absolute;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    border: 1px solid var(--blue-layout-400-primary);
  }
}
